export default "__VITE_ASSET__dbba42a0__"